<template>
  <span>
    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 5 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-A-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 10 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-A-1-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 15 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-A-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 20 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-A-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 25 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-A-2-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 30 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-A-3-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 35 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-A-3-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 40 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-A-3-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 45 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-B-1-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 50 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-B-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 55 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-B-1-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 60 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-B-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 65 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-B-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 70 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-B-2-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 75 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-i-1-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 80 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-i-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 85 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-i-1-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 90 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-i-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 95 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-i-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 95 && perguntaObj.percentual.tema.nome === 'Liderança'"
      :src="require('@/assets/img/mapa/AGR/AGR-i-2-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>
  </span>
</template>

<script>
export default {
  props: {
    perguntaObj: { type: Object, required: true }
  }
}
</script>
